module.exports = __webpack_public_path__ + "img/popular.c4cdb856.svg";